module.exports = __webpack_public_path__ + "static/media/android.a65f40dc.svg";